<template>
  <div class="login" :class="{ 'student': mode > 1 }">
    <div class="login-content">
      <div class="left" :class="{ 'student': mode > 1 }"></div>
      <div class="right">
        <el-card class="login-card">
          <h2 class="title">百项过智能学习</h2>
          <el-form v-show="mode === 1" class="admin-form" :model="schoolForm">
            <el-form-item>
              <h3 class="hint">学校登录：</h3>
              <el-input
                ref="schoolCode"
                v-model="schoolForm.schoolCode"
                @keyup.enter.native="autoFocus('schoolPassword')"
                placeholder="学校账号"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                ref="schoolPassword"
                v-model="schoolForm.schoolPassword"
                @keyup.enter.native="preLogin"
                type="password"
                autocomplete="new-password"
                placeholder="学校密码"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item class="text-ar">
              <el-button @click="preLogin" type="primary" class="btn-login btn-primary">
                确定
              </el-button>
            </el-form-item>
          </el-form>
          <el-form v-show="mode === 2"  class="admin-form" :model="form" ref="form">
            <el-form-item prop="account">
              <h3 class="hint">学生登录：</h3>
              <el-input
                v-model.trim="form.account"
                ref="account"
                @keyup.enter.native="autoFocus('password')"
                placeholder="账号"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                ref="password"
                v-model.trim="form.password"
                type="password"
                @keyup.enter.native="login"
                maxlength="30"
                autocomplete="new-password"
                placeholder="密码">
              </el-input>
            </el-form-item>
            <el-form-item class="text-ar">
              <el-button class="normal btn-primary" type="primary" @click="login">登录</el-button>
            </el-form-item>
            <div class="back-school">
              <span @click="mode = 3">忘记密码</span>
              <span @click="backSchool">返回学校登录</span>
            </div>
          </el-form>
          <el-form v-show="mode === 3" class="forget-form" :model="forgetForm">
            <el-form-item>
              <h3 class="hint">忘记密码：</h3>
              <el-input
                v-model="forgetForm.phone"
                ref="phone"
                @keyup.enter.native="autoFocus('code')"
                placeholder="学生手机号"
                maxlength="11">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="forgetForm.code"
                type="text"
                ref="code"
                @keyup.enter.native="autoFocus('newPassword')"
                autocomplete="new-password"
                placeholder="验证码"
                maxlength="6">
                <van-countdown
                  v-if="sended"
                  @timeout="sended = false"
                  :seconds="60"
                  slot="append" />
                <el-button v-else @click="sendCode" class="verify-btn" slot="append">
                  <span>获取验证码</span>
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="forgetForm.password"
                ref="newPassword"
                @keyup.enter.native="autoFocus('repeat')"
                type="password"
                autocomplete="new-password"
                placeholder="请输入新密码"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="forgetForm.repeatPassword"
                ref="repeat"
                type="password"
                @keyup.enter.native="forgetPassword"
                autocomplete="new-password"
                placeholder="请再输入一次新密码"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item class="text-ar">
              <span class="back" @click="mode = 2">返回学生登录</span>
              <el-button @click="forgetPassword" type="primary" class="btn-login btn-primary">
                确定
              </el-button>
            </el-form-item>
          </el-form>
          <van-help />
        </el-card>
      </div>
    </div>
    <van-footer></van-footer>
  </div>
</template>

<script>
import VanFooter from "@/components/Footer.vue";
import utils from "@/services/utils";
import api from "@/api/graphql/account";
import apiLearning from "@/api/graphql/learning";
import VanCountdown from "@/components/common/Countdown.vue";
import VanHelp from "@/components/common/Help.vue";

import { Button, Card, Form, FormItem, Input } from "element-ui";

export default {
  name: "login",
  components: {
    ElCard: Card,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
    VanFooter,
    VanCountdown,
    VanHelp
  },
  data() {
    return {
      mode: 1, // 1: 学校登录  2: 学生登录  3: 忘记密码
      isPass: false,
      schoolForm: {
        schoolCode: "",
        schoolPassword: ""
      },
      form: {
        account: "",
        password: "",
        schoolToken: ""
      },
      forgetForm: {
        phone: "",
        code: "",
        password: "",
        repeatPassword: ""
      },
      sended: false,
      isAllowLogin: true
    };
  },
  watch: {
    form: {
      handler() {
        if (this.form.schoolToken) {
          this.mode = 2;
        }
      },
      deep: true
    },
    mode: {
      handler() {
        this.$nextTick(() => {
          if (this.mode === 1) {
            this.$refs.schoolCode.focus();
          } else if (this.mode === 2) {
            this.$refs.account.focus();
          } else {
            this.$refs.phone.focus();
          }
        });
      },
      immediate: true
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const code = utils.params("code");
      const school = utils.storage("school");
      if (school) {
        this.mode = 2;
        this.form.schoolToken = utils.storage("school_token");
      } else if (code) {
        this.autoPreLogin(code);
      } else if (utils.storage("school_token")) {
        this.form.schoolToken = utils.storage("school_token");
      }
    },
    preLogin() {
      const verified = this.isPreLoginVerified();
      if (!verified || !this.isAllowLogin) {
        return;
      }

      this.isAllowLogin = false;

      api
        .preLogin(this.schoolForm)
        .then(({ preLogin }) => {
          this.isAllowLogin = true;
          this.form.schoolToken = preLogin.schoolToken;
          utils.storage("school_token", preLogin.schoolToken);
        })
        .catch(() => {
          this.isAllowLogin = true;
        });
    },
    autoFocus(name) {
      this.$refs[name].focus();
    },
    isPreLoginVerified() {
      if (this.isBlankText(this.schoolForm.schoolCode)) {
        utils.error("学校账号不能为空");
        return false;
      }

      if (this.isBlankText(this.schoolForm.schoolPassword)) {
        utils.error("学校密码不能为空");
        return false;
      }
      return true;
    },
    login() {
      const verified = this.isLoginVerified();
      if (!verified || !this.isAllowLogin) {
        return;
      }

      this.isAllowLogin = false;

      api
        .login(this.form)
        .then(res => {
          this.isAllowLogin = true;
          utils.login(res.login);
          this.autoSkip();
        })
        .catch(() => {
          this.isAllowLogin = true;
        });
    },
    isLoginVerified() {
      if (this.isBlankText(this.form.account)) {
        utils.error("学生账号不能为空");
        return false;
      }

      if (this.isBlankText(this.form.password)) {
        utils.error("学生密码不能为空");
        return false;
      }
      return true;
    },
    backSchool() {
      utils.storage("school_token", null);
      this.mode = 1;
      this.schoolForm = {
        schoolCode: "",
        schoolPassword: ""
      };
      this.form = {
        account: "",
        password: "",
        schoolToken: ""
      };
      this.$nextTick(() => {
        this.$refs.schoolCode.focus();
      });
    },
    forgetPassword() {
      if (this.forgetForm.password !== this.forgetForm.repeatPassword) {
        utils.error("两次输入的密码不一致");
        return;
      }
      api.forgetPassword(this.forgetForm).then(() => {
        this.forgetForm = {
          phone: "",
          code: "",
          password: "",
          repeatPassword: ""
        };
        this.mode = 2;
      });
    },
    sendCode() {
      const { phone } = this.forgetForm;
      if (!phone) {
        utils.error("请输入手机号");
        return;
      }
      if (!/^1[3456789][0-9]{9}$/.test(phone)) {
        utils.error("请输入正确的手机号");
        return;
      }
      this.sended = true;
      api
        .sendCaptcha({
          phone,
          type: "student_user_forget_password"
        })
        .then(() => {})
        .catch(() => {
          this.sended = false;
        });
    },
    isBlankText(text) {
      return !text || /^\s*$/.test(text);
    },
    autoPreLogin(code) {
      api
        .fetchSchoolToken({
          code
        })
        .then(({ fetchSchoolToken }) => {
          this.form.schoolToken = fetchSchoolToken.schoolToken;
          utils.storage("school_token", fetchSchoolToken.schoolToken);
        });
    },
    autoSkip() {
      apiLearning.getCourseList().then(({ courses }) => {
        const { lastTimeLearnedBook } = courses;
        const { code, id, isExpire } = lastTimeLearnedBook;
        utils.storage("bookInfo", lastTimeLearnedBook);
        if (id && !isExpire) {
          this.$router.replace(`learning-center/${code}/course/${id}`);
        } else {
          this.$router.replace("learning-center/elective");
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.login {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 680px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-size: cover;
  background-image: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/cad75680b34a15f8269b01ee08aa29d4.png");
  &.student {
    background-image: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/41bf35ead78a080af68d1c5a11a607c5.png");
  }
  a {
    text-decoration: none;
    color: $grey-color;
  }
  .text-align-right {
    text-align: right;
  }
  .login-content {
    width: 90%;
    height: 80%;
    min-height: 600px;
    display: flex;
    justify-content: space-between;
    border-radius: 20px;
    box-shadow: 2px 3px 3px 1px rgba(0, 0, 0, 0.3);
    .left {
      width: 70%;
      min-width: 510px;
      overflow: hidden;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      background-image: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/35a7606bbc9168048d59073bc83ea66f.png");
      background-size: cover;
    }
    .left.student {
      background-image: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/d3f4a3ed81b242585a5616b133bef087.png");
    }
    .right {
      width: 30%;
      min-width: 450px;
      /*overflow: hidden;*/
      text-align: center;
      .el-card {
        border-radius: 0;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .login-card {
    position: relative;
    height: 100%;
    .title {
      color: #a6004f;
      font-size: 34px;
      margin: 80px auto;
      letter-spacing: 2px;
    }
    .logo {
      margin: 15px auto;
      width: 160px;
    }
    .el-card__body {
      padding: 0;
      .el-form {
        text-align: left;
        margin: 0;
        padding: 0px 40px;
        .el-form-item {
          margin-top: 20px;
          margin-bottom: 0;
          &.last {
            margin-top: 30px;
          }
          .el-button {
            width: 100%;
          }
          .normal {
            width: 60%;
          }
          .try {
            float: right;
            width: 35%;
          }
          &:first-child {
            margin-top: 0;
          }
          button {
            height: 48px;
            border-radius: 10px;
            font-size: 18px;
          }
          .btn-login.el-button.el-button--primary {
            width: 226px;
          }
        }
        .el-form-item.text-ar {
          margin-top: 50px;
        }
        .back-school {
          padding-top: 38px;
          color: $primary;
          font-size: 18px;
          letter-spacing: 2px;
          span {
            text-decoration: underline;
            cursor: pointer;
          }
          span:first-child {
            float: left;
          }
          span:last-child {
            float: right;
          }
        }
        @media screen and (max-height: 820px) {
          .el-form-item.text-ar {
            margin-top: 24px;
          }
          .back-school {
            padding-top: 24px;
          }
        }
      }
    }
    .van-help {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
    }
    .hint {
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 2px;
      margin-top: 0;
      margin-bottom: 20px;
    }
    .admin-form .el-input__inner {
      height: 48px;
      line-height: 48px;
      border-radius: 10px;
      background-color: #f6f5fb;
    }
    .forget-form {
      margin-top: -50px !important;
      .el-form-item {
        margin-top: 15px !important;
      }
      .el-input-group__append {
        padding: 0;
      }
      .verify-btn {
        margin: -10px 20px;
        width: auto !important;
        height: auto !important;
      }
      .el-input__inner {
        height: 44px;
      }
      .countdown {
        padding: 0 20px;
        &:hover {
          cursor: not-allowed;
        }
        height: 36px;
        .seconds {
          line-height: 36px;
          font-size: 28px;
        }
      }
    }
    .text-ar {
      .back {
        float: left;
        font-size: 18px;
        line-height: 48px;
        color: $primary;
        text-decoration: underline;
        cursor: pointer;
      }
      text-align: right;
    }
  }
  .btn-primary.el-button--primary {
    background-image: linear-gradient(to right, #2d80e2, #4eaff5);
    border: none;
    &:hover {
      background-image: linear-gradient(to bottom, #2d80e2, #4eaff5);
      /*background-position: right top;*/
    }
  }
  .footer {
    font-size: 14px;
    color: #fff;
    bottom: 10px;
  }
}
</style>
